<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
      Role List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
              Add Role
            </v-btn>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    :data="table"
                    :fields="field_export"
                    worksheet="Roles"
                    name="Roles.xls"
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    worksheet="Roles"
                    name="Roles.xls"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportAllFitered"
                    :fields="field_export"
                    worksheet="Roles"
                    name="Roles.xls"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      fixed-header
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >
    <template v-slot:[`item.permission`]="{ item }">
          <v-btn
            color="primary"
            dark
            x-small
            @click="viewPermission(item.id, item.name, item.division_id)"
          >
            <v-icon dark x-small>
              key
            </v-icon>
          </v-btn>
    </template>
     
     <template v-slot:[`item.actions`]="{ item }">
      <!-- <v-icon
        small
        class="mr-2"
        @click="editData(item.id)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteData(item.id)"
      >
        mdi-delete
      </v-icon> -->
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="role.update" @click="editData(item.id)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role.delete" @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
  <modal ref="modalList" class="coba">
      <template v-slot:header>
        <h3>List Permission</h3>
      </template>

      <template v-slot:body>
        <list-permission :data_id="$refs.modalList.data" />
      </template>

      <template v-slot:footer>
        <md-card-actions>
          <md-button @click="modalCloseList">
            Close
          </md-button>
        </md-card-actions>
      </template>
    </modal>
</div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import { Modal } from "@/components"
import ListPermission from "@/pages/Dashboard/Admin/Role/modal/ListPermission.vue"
import { ResizablePage } from "@/components";

  export default {
    components: {
    Modal,
    downloadExcel: JsonExcel,
    ListPermission,ResizablePage
  },
    vuetify,
    data () {
      return {
        loadTable: true,
        role: "",
        search: '',
        headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
          },
          { text: 'Role Name', value: 'name' },
          { text: 'Division', value: 'division_name' },
          { text: 'Permission', value: 'permission', align: 'center', sortable: false },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        table: [],
        exportDisplayedPage:[],
        exportAllFitered:[],
        field_export: {
          name: "name",
          division: "division_name",
          created_at: "created_at",
          updated_at: "updated_at",
        },
      }
    },
    async created() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
     
      await this.$store.dispatch("role/list");
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["role/list"];
      // }
      // else{
      //   this.table = []
      // }
      this.loadTable= false
    },

    getFiltered(data){
    this.exportDisplayedPage = data
    if(this.$refs.vTable){
      this.exportAllFitered = this.$refs.vTable.$children[0].filteredItems
    }
    else{
      this.exportAllFitered = this.table
    }
    },

     
    // fungsi tombol direct ke add page
    addData() {
      // panggil add page
     this.$router.push({ name: "Add Role" });
    },

    // fungsi tombol direct ke edit page
    editData(id) {
      // panggil edit page
      this.$router.push({ name: "Edit Role", params: { id: id } });
    },

    viewPermission(id, name, division_id) {
      console.log(id+" - "+name+" - "+division_id)
      var indexOptionTable = this.table.findIndex(p => p.id ==  id)
      var data = this.table[indexOptionTable]["permission"];
      var grouped = _.mapValues(_.groupBy(data, "name_model"), (clist) =>
        clist.map((data) => _.omit(data, "name_model"))
      );

      //console.log(grouped);
      var dataPermission = [];
      Object.entries(grouped).forEach(([key, value]) => {
        // var dataPermission=[];
        // Object.entries(value).forEach(([key, value]) => {
        // console.log(key + ' - ' + value['permission_type']) // key - value
        // if(){

        // }
        // })
        // if(value.some(data => data.permission_type === "view")){
        //   console.log("ada")
        // }
        var menuP = 0;
        var createP = 0;
       // var editP = 0;
        var updateP = 0;
        var deleteP = 0;
        var requesterP = 0;
        var approverP = 0;
        // value.some(data => data.permission_type === "view") ? dataPermission.push({view:1}) : dataPermission.push({view:0});
        // value.some(data => data.permission_type === "create") ? dataPermission.push({create:1}) : dataPermission.push({create:0});
        // value.some(data => data.permission_type === "edit") ? dataPermission['edit'] = 1 : dataPermission['edit'] = 0;
        // value.some(data => data.permission_type === "update") ? dataPermission['update'] = 1 : dataPermission['update'] = 0;
        // value.some(data => data.permission_type === "delete") ? dataPermission['delete'] = 1 : dataPermission['delete'] = 0;

        value.some((data) => data.permission_type === "menu")
          ? (menuP = 1)
          : (menuP = 0);
        value.some((data) => data.permission_type === "create")
          ? (createP = 1)
          : (createP = 0);
        // value.some((data) => data.permission_type === "edit")
        //   ? (editP = 1)
        //   : (editP = 0);
        value.some((data) => data.permission_type === "update")
          ? (updateP = 1)
          : (updateP = 0);
        value.some((data) => data.permission_type === "delete")
          ? (deleteP = 1)
          : (deleteP = 0);
        value.some((data) => data.permission_type === "requester")
          ? (requesterP = 1)
          : (requesterP = 0);
        value.some((data) => data.permission_type === "approver")
          ? (approverP = 1)
          : (approverP = 0);

        dataPermission.push({
          model: key,
          model_id: value[0]["model_id"],
          menu: menuP,
          create: createP,
          //edit: editP,
          update: updateP,
          delete: deleteP,
          requester: requesterP,
          approver: approverP,
        });
      });
      this.$refs.modalList.openModal({
        id: this.table[indexOptionTable]["id"],
        data: dataPermission,
        name: name,
        division_id: division_id,
        id_index: indexOptionTable,
      });
      //console.log(dataPermission)
    },

    modalCloseList() {
      this.$refs.modalList.closeModal();
    },
    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },

     // fungsi delete
    async deleteData(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("role/destroy", id);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "User data delete successfully."
        );
        //await this.getList();
        var indexOptionTable = this.table.findIndex(p => p.id ==  id)
           this.table.splice(indexOptionTable, 1)
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },
     },
  }
</script>
<style lang="scss" scoped>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>